import { useI18n, LANGS } from "@/lib/i18n/i18n";

export const LangSwitcher = ({ dark = false, testPrefix = "lang", className = "" }) => {
  const { lang, setLang, t } = useI18n();
  return (
    <div role="group" aria-label={t("Idioma")} className={`flex items-center gap-0.5 rounded-full p-0.5 ${dark ? "bg-white/10" : "border border-slate-200 bg-white"} ${className}`} data-testid={`${testPrefix}-switcher`}>
      {LANGS.map((l) => (
        <button
          key={l.id}
          onClick={() => setLang(l.id)}
          className={`rounded-full px-2 py-1 text-[11px] font-bold tracking-wider transition-colors ${lang === l.id ? (dark ? "bg-white text-slate-950" : "bg-slate-950 text-white") : dark ? "text-white/60 hover:text-white" : "text-slate-500 hover:text-slate-900"}`}
          data-testid={`${testPrefix}-${l.id}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
